import { CUSTOMER_JOURNEY_MENU } from './../const';

function action(token, lang, context) {
  return { type: CUSTOMER_JOURNEY_MENU, token, lang, context };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyMenu.js